<app-configuration-list></app-configuration-list>